export default {
  state: {
    dropzone: {
      show: false,
      items: [],
      checkRoute: false,
      calculatingRun: false,
      associatedRuns: []
    }
  },
  mutations: {
    setDropzoneData (state, data) {
      for (let field in data) {
        state.dropzone[field] = data[field]
      }
    },
    addDropzoneItem (state, value) {
      value['newPickupTime'] = null
      value['newEta'] = null
      state.dropzone.items.push(value)
    },
    removeDropzoneItem (state, data) {
      let index = state.dropzone.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.dropzone.items.splice(index , 1)
      }
    },
    removeDropzoneItems (state, value) {
      let items = state.dropzone.items
      if (value.type === 'rsvp') {
        state.dropzone.items = items.filter(item => item.id !== value.id)
        return
      }

      state.dropzone.items = items.filter(item => item.runId !== value.id)
    },
    clearDropzone (state) {
      state.dropzone.show = false
      state.dropzone.items = []
      state.dropzone.checkRoute = false
      state.dropzone.drivers = []
    },
    addAssociatedRuns (state, value) {
      let index = state.dropzone.associatedRuns.indexOf(value)
      if (index === -1) {
        state.dropzone.associatedRuns.push(value)
      }
    },
    removeAssociatedRuns (state, value) {
      let index = state.dropzone.associatedRuns.indexOf(value)
      if (index > -1) {
        state.dropzone.associatedRuns.splice(index, 1)
      }
    },
    updateNextInfo (state, data) {
      let index = state.dropzone.items.findIndex(x => x.id === data.id)
      if (index > -1) {
        state.dropzone.items[index].timeToNext = data.timeToNext
        state.dropzone.items[index].distanceToNext = data.distanceToNext
      }
    },
    updateDropzoneItem (state, data) {
      state.dropzone.items[data.index].newPickupTime = data.pickupTime
      state.dropzone.items[data.index].newEta = data.eta
      state.dropzone.items[data.index].timeToNext = data.timeToNext
      state.dropzone.items[data.index].distanceToNext = data.distanceToNext
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/runs/dropzone.js